/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigChangeResponse } from './ConfigChangeResponse';
import {
    ConfigChangeResponseFromJSON,
    ConfigChangeResponseFromJSONTyped,
    ConfigChangeResponseToJSON,
} from './ConfigChangeResponse';

/**
 * A config's change history, newest first
 * @export
 * @interface ConfigChangeListResponse
 */
export interface ConfigChangeListResponse {
    /**
     * 
     * @type {Array<ConfigChangeResponse>}
     * @memberof ConfigChangeListResponse
     */
    items: Array<ConfigChangeResponse>;
}

/**
 * Check if a given object implements the ConfigChangeListResponse interface.
 */
export function instanceOfConfigChangeListResponse(value: object): value is ConfigChangeListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ConfigChangeListResponseFromJSON(json: any): ConfigChangeListResponse {
    return ConfigChangeListResponseFromJSONTyped(json, false);
}

export function ConfigChangeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigChangeListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ConfigChangeResponseFromJSON)),
    };
}

export function ConfigChangeListResponseToJSON(value?: ConfigChangeListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(ConfigChangeResponseToJSON)),
    };
}

